import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const useChangeStep = () => {
  const { search } = useLocation();
  const navigate = useNavigate();

  return useCallback(
    (pathname, replace) =>
      navigate({ pathname, search, ...(!!replace && { replace: true }) }),
    [navigate, search]
  );
};
export default useChangeStep;
